
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_mgja0_tf552_13",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_mgja0_tf552_1",
  "root": "awsui_root_mgja0_tf552_36",
  "wide": "awsui_wide_mgja0_tf552_67",
  "focus-lock": "awsui_focus-lock_mgja0_tf552_74",
  "trigger-flexbox": "awsui_trigger-flexbox_mgja0_tf552_78",
  "calendar-container": "awsui_calendar-container_mgja0_tf552_82",
  "one-grid": "awsui_one-grid_mgja0_tf552_85",
  "calendar-header": "awsui_calendar-header_mgja0_tf552_89",
  "calendar-header-pages-wrapper": "awsui_calendar-header-pages-wrapper_mgja0_tf552_95",
  "calendar-header-page": "awsui_calendar-header-page_mgja0_tf552_95",
  "date-and-time-container": "awsui_date-and-time-container_mgja0_tf552_115",
  "date-and-time-wrapper": "awsui_date-and-time-wrapper_mgja0_tf552_121",
  "footer": "awsui_footer_mgja0_tf552_128",
  "has-clear-button": "awsui_has-clear-button_mgja0_tf552_137",
  "footer-button-wrapper": "awsui_footer-button-wrapper_mgja0_tf552_146",
  "icon-wrapper": "awsui_icon-wrapper_mgja0_tf552_153",
  "label": "awsui_label_mgja0_tf552_158",
  "label-enabled": "awsui_label-enabled_mgja0_tf552_162",
  "label-text": "awsui_label-text_mgja0_tf552_166",
  "label-token-nowrap": "awsui_label-token-nowrap_mgja0_tf552_172",
  "dropdown": "awsui_dropdown_mgja0_tf552_176",
  "dropdown-content": "awsui_dropdown-content_mgja0_tf552_198"
};
  